<script>
    import { getTopAreaHeight } from '../../utils/utils';

    export default {
        name: 'DownloadListBlock',
        props: {
            items: { type: Array, default: () => [] },
            fields: { type: Array, default: () => [] },
            showGating: { type: Boolean, default: false }
        },
        data() {
            return {
                tableFields: [],
                gated: false,
                lastClickedDocument: '',
                formIsLoaded: false,
                sortOrder: 'none',
                sortBy: '',
                isExtended: false,
                formLoading: false,
                downloadList: null
            };
        },
        created() {
            // Initialize table fields from props
            this.tableFields = this.items;
        },
        mounted() {
            this.$el.addEventListener('keyup', (e) => {
                if (e.keyCode === 27 && this.isExtended) {
                    const parentEl = this.$parent?.$el || this.$el.parentElement || this.$el;
                    const parent = window.$(parentEl);
                    const extendableForm = parent.find('.extendableForm');
                    extendableForm.find('button').click();
                }
            });
            this.downloadList = $(this.$el).find('.table-responsive');
            window.addEventListener('beforeprint', this.hideFromPrint);
            window.addEventListener('afterprint', this.showAfterPrint);
            this.$el.addEventListener('add-gating', this.addGating);
            this.$el.addEventListener('remove-downloadable-gating-all', this.removeGatingAll);
            this.$el.addEventListener('remove-downloadable-gating-all-and-open', this.removeGatingAllAndOpen);
            this.$el.addEventListener('remove-downloadable-gating-single', this.removeGatingSingle);
            this.onTableResize();
            window.addEventListener('resize', this.onTableResize);
            this.downloadList.on('scroll', this.onTableScroll);
            if (this.showGating) {
                const $iframe = $(this.$el).find('iframe');
                if ($iframe.length) {
                    const event = new CustomEvent('reinitFormHandlers', { detail: { iframeId: $iframe.attr('id') } });
                    window.dispatchEvent(event);
                }
                this.addGating();
            }
        },
        beforeUnmount() {
            window.removeEventListener('beforeprint', this.hideFromPrint);
            window.removeEventListener('afterprint', this.showAfterPrint);
            window.removeEventListener('resize', this.onTableResize);
        },
        methods: {
            getRowIndex(i, n, length) {
                let index = i;
                if (n > 0) {
                    index += n * length - 1;
                };
                return index;
            },
            sortItemsOnEnter(e, key) {
                if (e.key === 'Enter') this.sortItems(key);
            },
            sortItems(key) {
                this.sortOrder = this.sortBy === key
                    ? (this.sortOrder === 'descending' ? 'ascending' : 'descending')
                    : 'ascending';
                this.sortBy = key;
                // if downloadsTable block with multiple groups of documents
                if (this.tableFields[0] && this.tableFields[0].documents) {
                    this.tableFields.forEach(field => {
                        field.documents.sort((a, b) => {
                            const valueA = a[key];
                            const valueB = b[key];
                            if (!isNaN(valueA) && !isNaN(valueB)) {
                                return this.sortOrder === 'ascending' ? valueA - valueB : valueB - valueA;
                            }
                            return this.sortOrder === 'ascending'
                                ? String(valueA).localeCompare(String(valueB))
                                : String(valueB).localeCompare(String(valueA));
                        });
                    });
                }
                else {
                    this.tableFields.sort((a, b) => {
                        const valueA = a[key];
                        const valueB = b[key];
                        if (!isNaN(valueA) && !isNaN(valueB)) {
                            return this.sortOrder === 'ascending' ? valueA - valueB : valueB - valueA;
                        }
                        return this.sortOrder === 'ascending'
                            ? String(valueA).localeCompare(String(valueB))
                            : String(valueB).localeCompare(String(valueA));
                    });
                }
            },
            isLink(item) {
                return item.fileSize === 0;
            },
            linkClicked(item, e) {
                if (this.gated && item.downloadLink.gated) {
                    e.preventDefault();
                } else {
                    e.stopImmediatePropagation?.();
                }
            },
            rowClicked(data, index) {
                if (!this.formIsLoaded) this.loadForm();
                this.lastClickedDocument = data.downloadLink.link;
                if (this.gated && data.downloadLink.gated) {
                    this.extendForm(data.downloadLink.link, index);
                } else {
                    const a = document.createElement('a');
                    a.href = this.lastClickedDocument;
                    a.target = data.downloadLink.linkTarget || '_blank';
                    a.rel = 'noopener noreferrer';
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                if (window.dataLayer) {
                    window.dataLayer.push({
                        'item-name': data.title,
                        event: 'download',
                        gated: data.gatedDocument
                    });
                }
            },
            mobileRowClicked(link, index) {
                if (!this.formIsLoaded) this.loadForm();
                this.extendForm(link, index);
            },
            loadForm() {
                const iframe = window.$(this.$el).find('iframe');
                iframe.attr('src', iframe.data('src'));
                iframe.on('load', () => {
                    this.formLoading = false;
                    this.formIsLoaded = true;
                });
            },
            addGating() {
                this.gated = true;
            },
            showAfterPrint() { this.changeGatedRowsClass('table-row'); },
            hideFromPrint() { this.changeGatedRowsClass('none'); },
            changeGatedRowsClass(displayStyle) {
                const rows = this.$el.getElementsByClassName('download-table-row');
                for (let i = 0; i < this.tableFields.length; i++) {
                    if (this.tableFields[i].gatedDocument && rows[i]) {
                        rows[i].style.display = displayStyle;
                    }
                }
            },
            removeGatingAll() {
                this.tableFields.forEach(d => {
                    d.gatedDocument = false;
                    d.downloadLink.gated = false;
                });
            },
            removeGatingAllAndOpen() {
                this.removeGatingAll();
                window.open(this.lastClickedDocument, '_blank');
            },
            removeGatingSingle() {
                for (let i = 0; i < this.tableFields.length; i++) {
                    if (this.tableFields[i].downloadLink.link === this.lastClickedDocument) {
                        this.tableFields[i].downloadLink.gated = false;
                        this.tableFields[i].gatedDocument = false;
                        break;
                    }
                }
                window.open(this.lastClickedDocument, '_blank');
            },
            extendForm(documentUrl, index) {
                if (!this.gated) return;
                const transitionLength = 500;
                const parentEl = this.$parent?.$el || this.$el.parentElement || this.$el;
                const parent = window.$(parentEl);
                const extendableForm = parent.find('.extendableForm');
                const rootEl = this.$el;
                let formHeight =
                    extendableForm.find('.iframe-form-block__content').outerHeight() +
                    extendableForm.find('.extendableForm__title').outerHeight();
                const expand = (i) => {
                    parent.addClass('extended');
                    extendableForm.height(formHeight + 'px').addClass('expanding');
                    setTimeout(() => {
                        extendableForm.removeClass('expanding').addClass('extended').height('').attr('tabindex', '0').focus().one('keyup', handleEscapePress);
                        extendableForm.find('button').on('click', collapse);
                        window.$(rootEl).find('.download-table-row').eq(i)
                            .addClass('row-expanded');
                        window.$('html, body').stop().animate(
                            { scrollTop: extendableForm.offset().top - getTopAreaHeight() },
                            transitionLength,
                            'swing'
                        );
                        this.lastClickedDocument = documentUrl;
                        setTimeout(() => {
                            [...rootEl.getElementsByClassName('success-download-link')].forEach(elem => {
                                elem.href = this.lastClickedDocument;
                                elem.dispatchEvent(new Event('change'));
                            });
                        }, transitionLength);
                    }, transitionLength);
                    this.isExtended = true;
                }

                const collapse = () => {
                    formHeight =
                        extendableForm.find('.extendableForm__content').outerHeight() +
                        extendableForm.find('.extendableForm__title').outerHeight();
                    parent.removeClass('extended');
                    extendableForm.height(formHeight).height(0);
                    extendableForm.find('button').off('click', collapse);
                    extendableForm.addClass('collapsing');
                    setTimeout(() => {
                        extendableForm.removeClass('collapsing extended').attr('tabindex', '-1');
                        window.$(rootEl).find('.download-table-row').eq(index).removeClass('row-expanded').find('a').focus();
                        window.$('html, body').stop().animate(
                            { scrollTop: $(this.$el).offset().top - getTopAreaHeight() },
                            transitionLength,
                            'swing'
                        );
                    }, transitionLength);
                    this.isExtended = false;
                }

                if (parent.hasClass('extended')) {
                    if (window.$(rootEl).find('.download-table-row').eq(index).hasClass('row-expanded')) {
                        collapse(index);
                    } else {
                        collapse(window.$(rootEl).find('.row-expanded').index());
                        window.$(rootEl).find('.download-table-row.row-expanded').removeClass('row-expanded');
                        setTimeout(() => expand(index), transitionLength * 2);
                    }
                } else {
                    expand(index);
                }

                function handleEscapePress(e) {
                    if (e.which === 27) {
                        window.$(e.target).find('button').click();
                    }
                }
            },
            clearSuccessMessage() {
                [...this.$el.getElementsByClassName('fill-form-step')]
                    .forEach(elem => elem.style.display = 'block');
                [...this.$el.getElementsByClassName('submission-successful')]
                    .forEach(elem => elem.style.display = 'none');
            },
            onTableResize() {
                const $dl = this.downloadList;
                if (!$dl.length) return;
                const clientWidth = $dl.get(0).clientWidth;
                const scrollWidth = $dl.get(0).scrollWidth;
                $dl.toggleClass('has-horizontal-scrollbar', clientWidth < scrollWidth);
            },
            onTableScroll() {
                const $dl = this.downloadList;
                if (!$dl.length) return;
                const scrollLeft = this.downloadList.scrollLeft();
                this.downloadList.toggleClass('scrolling', scrollLeft > 0);
                const containerWidth = $dl.outerWidth();
                const $table = this.downloadList.find('table');
                const tableWidth = $table.length ? $table.outerWidth() : 0;
                const atEnd = tableWidth > 0 && (scrollLeft + containerWidth + 1 >= tableWidth);
                this.downloadList.toggleClass('scrolled-to-end', atEnd);
            }
        }
    };
</script>